import { useContext } from 'react';
import { createContext } from 'react';

import { GiftNameProps } from '../@types/GiftNameProps';

export const GiftNameContext = createContext<GiftNameProps>({} as GiftNameProps);

GiftNameContext.displayName = 'GiftName';

const GiftNameProvider = (props: GiftNameProps) => (
	<GiftNameContext.Provider value={props}>{props.children}</GiftNameContext.Provider>
);

export const useGiftName = () => {
	const context = useContext(GiftNameContext);

	return context;
};

export default GiftNameProvider;
